import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { useToastError } from 'lib/hooks';
import { linkedinKeys } from './queryKeys';
import { errorToast } from 'lib/components/toasts/error';

export const queryLinkedInVideoAnalytics = async (id: number) => {
  const response = await EXPRESS_API.get(`/linkedin/video/${id}/analytics`);
  const data = response.data;
  // LinkedIn API returns an object containing error details when there is an issue with the request.
  if (data.status === 404) {
    return;
  }
  if (data.status === 401) {
    errorToast({
      title: data.data.message,
    });
    return;
  }
  return data;
};

export const useQueryLinkedInVideoAnalytics = (
  id: number,
  enabled: boolean
) => {
  const { showError } = useToastError();
  return useQuery(
    linkedinKeys.linkedin_analytics(id),
    () => queryLinkedInVideoAnalytics(id),
    {
      onError: showError,
      refetchOnMount: true,
      enabled,
    }
  );
};
